import { Outlet } from 'react-router-dom'

export default function OutletGestaoClientes() {
  return <Outlet />
}
